import React, { useState , useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import Barcode from "react-barcode";
import AlertPage from "./alertPage";
import { toPng } from "html-to-image";
import "./BusinessCard.css";
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["businessCard"]?.[key] || fallback;

const BusinessCard = ({infoSource, userInfo, logo, companyName, role, qrValue, barcodeValue }) => {
    __setElakayInfoSource(infoSource);
    const [isFront, setIsFront] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const toggleCardSide = () => {
      setIsFront(!isFront);
    };
  const frontRef = useRef(null); // Référence pour la face avant
  const backRef = useRef(null);  // Référence pour la face arrière

  // Fonction pour télécharger un div en image
  const downloadDivAsImage = (ref, filename) => {
    if (!ref.current) return;
    toPng(ref.current)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${filename}.png`;
        link.click();
        alert(__elakayText("t003", "Image downloaded successfully!"));
      })
      .catch((err) => {
        console.error("Error generating image", err);
      });
  };

  const nameStyle = {
    position: "absolute",
    top: "50px", /* Espace depuis le bas */
    left: "10px", /* Espace depuis la droite */
    // backgroundColor: "#000000",
    padding: "5px 10px",
    // textAlign: "center",
    color: "black",
    borderRadius: "5px",
    fontFamily: "Arial, sans-serif",
    fontSize: "25px",
  }
  
 const roleStyle = {
    position: "absolute",
    bottom: "40px", /* Espace depuis le bas */
    left: "10px", /* Espace depuis la droite */
    // backgroundColor: "#000000",
    padding: "5px 10px",
    textAlign: "center",
    color: "black",
    borderRadius: "5px",
    fontFamily: "Arial, sans-serif",
    fontSize: "20px",
  }
  return (
    <div>
      <div className="business_card_container" onClick={toggleCardSide}>
      <AlertPage
        showAlert={showAlert} 
        setShowAlert={setShowAlert}
        messagetext={elakayAutoText("h_5f471387155775", "Image téléchargée avec succès !")}
        /> 
        {/* Front Face */}
        {isFront ? (
        <div className="business_card front p-2" ref={frontRef}>
          <div className="business_header">
            <div className="business_logo">
              <img src={logo} alt={__elakayText("t001", "Elakay logo")} className="business_logo_image" />
            </div>
            <div className="business_company_name">{companyName}</div>

          </div>

          <div className="business_footer">
            <div className="business_role">
            {userInfo?.lastname !== "elakay" && <h3 style={nameStyle}>{__elakayText("t002", "Member")}</h3>}
              <h5 style={roleStyle}>{role}</h5>
            </div>
            <div className="business_qr_code_container">
              {qrValue
                ? <QRCodeCanvas value={qrValue} size={85} />
                : <span className="business_qr_code_unavailable">{__elakayText("t004", "QR code unavailable")}</span>}
            </div>
          </div>
        </div>
 ) : (
       
        <div className="business_card back p-3" ref={backRef}>
            {/* Back Face */} 
          <div className="business_back_text">
            <p>
            {infoSource.language(infoSource, "text", "textBusinessCard")}
              {/* This card is a precious key. Do not let anyone scan its QR code
              until it is activated. Once activated, the QR code grants you a
              unique account. Use this account wisely, as it symbolizes your
              ability to effectively manage teams and oversee multiple
              companies. This card can serve as proof of your skills and open
              exceptional opportunities for you. */}
            </p>
          </div>
          <div className="business_barcode">
            {/* <Barcode value={barcodeValue} /> */}
          </div>
        </div>)}
      </div>  

      {/* Download Buttons */}

      <div style={{marginTop: "20px", display: "flex", gap: "10px"}}>
     { isFront ?  <button className="btn btn-outline-dark btn-md btn-block rounded-4" onClick={() => downloadDivAsImage(frontRef, "business_card_front")}>
     {infoSource.language(infoSource, "Button", "downloadFront")}
      {/* Download Front */}
        </button>
        :
        <button className="btn btn-outline-dark btn-md btn-block rounded-4" onClick={() => downloadDivAsImage(backRef, "business_card_back")}>
          {infoSource.language(infoSource, "Button", "downloadBack")}
          {/* Download Back */}
        </button>
        }
      </div>
    </div>
  );
};

export default BusinessCard;
